import { render } from "./MedicineSearch.vue?vue&type=template&id=3fa57d77&scoped=true"
import script from "./MedicineSearch.vue?vue&type=script&lang=js"
export * from "./MedicineSearch.vue?vue&type=script&lang=js"

import "./MedicineSearch.vue?vue&type=style&index=0&id=3fa57d77&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa57d77"]])

export default __exports__